import { combineReducers } from "redux";
import apiReducer from "./Api/Reducer";
import businessReducer from "./Business/Reducer";
import { BusinessUnitState } from "./BusinessUnit/PropTypes";
import businessUnitsReducer from "./BusinessUnit/Reducer";
import { CandidateState } from "./Candidate/PropTypes";
import candidateReducer from "./Candidate/Reducer";
import { ContactState } from "./Contact/PropTypes";
import contactReducer from "./Contact/Reducer";
import fieldmanagementReducer from "./FieldManagement/Reducer";
import contactModuleReducer from "./Modules/ContactModule/Reducer";
import fileReducer from "./Modules/Files/Reducer";
import { ModulesState } from "./Modules/PropTypes";
import noteReducer from "./Note/Reducer";
import notificationReducer from "./Notification/Reducer";
import settingsEntityReducer from "./Settings/Entities/Reducer";
import settingsEntityTypesReducer from "./Settings/EntityTypes/Reducer";
import settingsExtensionsReducer from "./Settings/Extensions/Reducer";
import settingsFieldsReducer from "./Settings/Fields/Reducer";
import settingsLayoutReducer from "./Settings/Layout/Reducer";
import settingsModulesReducer from "./Settings/Modules/Reducer";
import { SettingsState } from "./Settings/PropTypes";
import { UserState } from "./User/PropTypes";
import userReducer from "./User/Reducer";
import { VacancyState } from "./Vacancy/PropTypes";
import vacancyReducer from "./Vacancy/Reducer";
import offerReducer from 'Store/Offer/Reducer';

export interface StoreState {
    fieldmanagement: any,
    business_units: BusinessUnitState,
    contacts: ContactState,
    settings: SettingsState,
    candidates: CandidateState,
    users: UserState,
    vacancies: VacancyState,
    modules: ModulesState,
    offers: any
}

const reducer = combineReducers({
    notification: notificationReducer,
    users: userReducer,
    api: apiReducer,
    settings: combineReducers({
        entities: settingsEntityReducer,
        entity_types: settingsEntityTypesReducer,

        layouts: settingsLayoutReducer,
        fields: settingsFieldsReducer,

        modules: settingsModulesReducer,
        extensions: settingsExtensionsReducer
    }),
    modules: combineReducers({
        contact: contactModuleReducer,
        files: fileReducer
    }),
    fieldmanagement: fieldmanagementReducer,

    businesses: businessReducer,
    business_units: businessUnitsReducer,
    candidates: candidateReducer,
    contacts: contactReducer,
    vacancies: vacancyReducer,
    offers: offerReducer,

    notes: noteReducer
});

export default reducer;